import React from "react";
import { useTranslation } from "react-i18next";
import { Roles } from "src/@types/users";
import { Sizes } from "src/@types/sizes";
import { Show } from "src/components/PrivateRoute/Show";
import { Link } from "src/components/Link";
import { ReactComponent as PlusIcon } from "src/assets/icons/plus.svg";
import { ButtonVariants } from "src/components/Button/types";
import { Button } from "src/components/Button";
import { ActionBanner } from "src/components/ActionBanner";
import { PATHNAMES } from "src/constants/routes";
import { inquirySuggestionBannerTrns } from "./trns";

export const InquirySuggestionBanner = () => {
  const { t } = useTranslation();

  return (
    <ActionBanner
      title={t(inquirySuggestionBannerTrns.title)}
      description={t(inquirySuggestionBannerTrns.description)}
    >
      <Show onlyFor={Roles.AGENT} loaderSize={Sizes.M}>
        <Link href={PATHNAMES.CREATE_INQUIRY}>
          <Button
            variant={ButtonVariants.SECONDARY}
            className="gap-2 h-10 px-5 py-2 !text-black-base font-medium"
          >
            <PlusIcon />
            {t(inquirySuggestionBannerTrns.addInquiryButton)}
          </Button>
        </Link>
      </Show>
    </ActionBanner>
  );
};
